
import { convertToHtml, convertToDraftJs } from '../../components/Editor'
import React, { Component } from 'react'
import {
  Divider,
} from 'antd'

import Editor, { composeDecorators } from 'draft-js-plugins-editor';

import createImagePlugin from 'draft-js-image-plugin';
import createVideoPlugin from 'draft-js-video-plugin';
import createAlignmentPlugin from 'draft-js-alignment-plugin';
import createFocusPlugin from 'draft-js-focus-plugin';
import createResizeablePlugin from 'draft-js-resizeable-plugin';
import CustomAdd from './customAdd';
import createInlineToolbarPlugin, { Separator } from 'draft-js-inline-toolbar-plugin';
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
  CodeBlockButton,
} from 'draft-js-buttons';
import 'draft-js-inline-toolbar-plugin/lib/plugin.css';
import 'draft-js-alignment-plugin/lib/plugin.css';
import { connect } from 'react-redux';
import { handleChangeApp } from '../../actions/app'


const imagePlugin = createImagePlugin();

const inlineToolbarPlugin = createInlineToolbarPlugin();
const { InlineToolbar } = inlineToolbarPlugin;

const focusPlugin = createFocusPlugin();
const resizeablePlugin = createResizeablePlugin();
const alignmentPlugin = createAlignmentPlugin();
const { AlignmentTool } = alignmentPlugin;

const decorator = composeDecorators(
  resizeablePlugin.decorator,
  alignmentPlugin.decorator,
  focusPlugin.decorator,
);

const videoPlugin = createVideoPlugin({ decorator });

const plugins = [imagePlugin, videoPlugin, inlineToolbarPlugin, focusPlugin, alignmentPlugin, resizeablePlugin];


class Story extends Component {
  constructor(props) {
    super(props)
    const { app } = props

    const editorState = convertToDraftJs(app.story);
    this.state = {
      editorState,
      showImg: false,
      showVideo: false
    };
  }




  onChange(editorState) {

    const { handleChangeApp, app } = this.props
    let html = convertToHtml(editorState)
    app.story = html
    handleChangeApp(app)

    this.setState({
      editorState,
    });


  };

  focus() {
    this.editor.focus();
  };

  changeOpenDialog(name, value) {
    this.setState({
      [name]: value
    })
  }

  render() {
    const { showImg } = this.state
    return (
      <div className="project-flow">

        <h2 className="project-flow__title">Introduce your project</h2>
        <div className="project-flow__title project-flow__title-sub">Tell people why they should be excited about your project. Get specific but be clear and be brief.</div>
        <Divider />
        <div className="project-flow__footer-content">
          <h3 style={{ marginBottom: '20px' }} className="general-detail__campaign__group--title">App Story</h3>
          <p className="cardContent__price-sub">
            Story what you're raising funds to do, why you care about it, how you plan to make it happen, and who you are. Your description should tell backers everything they need to know. If possible, include images to show them what your project is all about and what rewards look like.
          </p>
        </div>

        <div>
          <div className="editor" onClick={() => { this.focus() }}>

            <Editor
              editorState={this.state.editorState}
              onChange={(editorState) => { this.onChange(editorState) }}
              plugins={plugins}
              ref={(element) => { this.editor = element; }}
            // textAlignment="center"
            />
            <InlineToolbar>
              {
                // may be use React.Fragment instead of div to improve perfomance after React 16
                (externalProps) => (
                  <div>

                    {/* <Separator {...externalProps} /> */}
                    <BoldButton {...externalProps} />
                    <ItalicButton {...externalProps} />
                    <UnderlineButton {...externalProps} />
                    <CodeButton {...externalProps} />
                    <Separator {...externalProps} />
                    <HeadlinesButton {...externalProps} />
                    <UnorderedListButton {...externalProps} />
                    <OrderedListButton {...externalProps} />
                    <BlockquoteButton {...externalProps} />
                    <CodeBlockButton {...externalProps} />
                  </div>
                )
              }
            </InlineToolbar>
            <AlignmentTool />
          </div>
          <CustomAdd
            editorState={this.state.editorState}
            onChange={(editorState) => { this.onChange(editorState) }}
            modifier={imagePlugin.addImage}
            name="Image "
            open={showImg}
            openPopover={() => {
              this.changeOpenDialog('showVideo', false)
              this.changeOpenDialog('showImg', !showImg)
            }}
          />
          {/* <CustomAdd
            type="video"
            editorState={this.state.editorState}
            onChange={(editorState) => { this.onChange(editorState) }}
            modifier={videoPlugin.addVideo}
            open={showVideo}
            name="Video "
            openPopover={() => {
              this.changeOpenDialog('showImg', false)
              this.changeOpenDialog('showVideo', !showVideo)
            }}
          /> */}
        </div>

      </div>
    )
  }
}



const mapStateToProps = state => ({
  app: state.app || {},
});

function mapDispatchToProps() {
  return {
    handleChangeApp: (data) => handleChangeApp(data)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Story);




class HeadlinesPicker extends Component {
  componentDidMount() {
    setTimeout(() => { window.addEventListener('click', this.onWindowClick); });
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  }

  onWindowClick = () =>
    // Call `onOverrideContent` again with `undefined`
    // so the toolbar can show its regular content again.
    this.props.onOverrideContent(undefined);

  render() {
    const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton];
    return (
      <div>
        {buttons.map((Button, i) => // eslint-disable-next-line
          <Button key={i} {...this.props} />
        )}
      </div>
    );
  }
}

class HeadlinesButton extends Component {
  // When using a click event inside overridden content, mouse down
  // events needs to be prevented so the focus stays in the editor
  // and the toolbar remains visible  onMouseDown = (event) => event.preventDefault()
  onMouseDown = (event) => event.preventDefault()

  onClick = () =>
    // A button can call `onOverrideContent` to replace the content
    // of the toolbar. This can be useful for displaying sub
    // menus or requesting additional information from the user.
    this.props.onOverrideContent(HeadlinesPicker);

  render() {
    return (
      <div onMouseDown={this.onMouseDown} className={'headlineButtonWrapper'}>
        <button onClick={this.onClick} className={'headlineButton'}>
          H
        </button>
      </div>
    );
  }
}